import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M2.5 8H12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
